import React, {useEffect, useState} from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../ui/Dialog/DialogActions";
import Checkbox from "../../../../../ui/Checkbox";
import Button from "../../../../../ui/Button";
import AddOrganizationForm from "../AddOrganizationForm";

const styles = () => ({
  dialog: {
    width: "550px"
  }
});

const AddOrganizationModal = ({
  open,
  handleClose,
  createRoom,
  isCreatingRoom,
  createdRoom,
  classes,
  history
}) => {
  const [checked, setChecked] = useState(false);
  const [formData, updateFormData] = useState(null);

  const onConfirm = () => {
    createRoom(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  useEffect(() => {
    if (createdRoom && createdRoom.success) {
      updateFormData(null);
      handleClose();

      if (checked) {
        history.push(`/work/app/organization/${createdRoom.id}`);
      }
    }
  }, [createdRoom]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Добавить организацию</DialogTitle>
        <DialogContent>
          <AddOrganizationForm
            onFormChange={updateFormData}
            disabled={isCreatingRoom}
          />
        </DialogContent>
        <DialogActions>
          <Checkbox
            label="Открыть форму для редактирования"
            checked={checked}
            handleChange={() => setChecked(!checked)}
          />
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingRoom}
            disabled={isCreatingRoom}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(AddOrganizationModal));
